/** CSS custom property synced to the fixed maintenance admin banner height. */
export const MAINTENANCE_BANNER_HEIGHT_CSS_VAR = '--bhg-maintenance-admin-banner-height';

/** Overlay top offset: maintenance banner (when present) + mobile top bar. */
export function mobileOverlayTopBelowTopBar(topBarHeightPx: number): string {
  return `calc(var(${MAINTENANCE_BANNER_HEIGHT_CSS_VAR}, 0px) + ${topBarHeightPx}px)`;
}
